// @ts-nocheck
import { handleError } from '@/utilities';
import store from '@/store';

const stripWww = (hostname) => hostname.replace(/^www\./i, '');

const isSameDomain = (domain, currentHostname) => {
  const strippedDomain = stripWww(domain);
  const strippedHostname = stripWww(currentHostname);
  return new RegExp(`.*${strippedHostname}$`).test(strippedDomain);
};

const isValidUrl = (href) => {
  try {
    return Boolean(new URL(href));
  } catch {
    return false;
  }
};

export async function addQueryParams() {
  const crossSiteTracking =
    store.config?.regionTemplate?.settings?.crossSiteTracking;
  const domains = store.config?.domains ?? [];

  if (!crossSiteTracking || domains.length === 0) {
    return;
  }

  const contextId = store.app.getContextId();
  if (!contextId) {
    return;
  }

  const currentHostname = window.location.hostname;
  const externalDomains = domains.filter(
    (domain) => !isSameDomain(domain, currentHostname),
  );

  if (externalDomains.length === 0) {
    return;
  }

  // Pre-compile RegExp patterns
  const domainPatterns = externalDomains.map((domain) => ({
    domain,
    regex: new RegExp(`.*${domain}$`),
  }));

  try {
    const elements = Array.from(document.getElementsByTagName('a'));
    if (elements.length === 0) return;
    elements.forEach((element) => {
      const href = element.getAttribute('href');
      if (href && isValidUrl(href)) {
        const url = new URL(href);
        domainPatterns.some(({ regex }) => {
          if (url.hostname.match(regex) !== null) {
            url.searchParams.set('_cord_id', contextId);
            element.setAttribute('href', url.href);
            return true; // stops iteration after first match
          }
          return false;
        });
      }
    });
  } catch (err) {
    handleError(err);
  }
}
